import { createActions, handleActions } from 'redux-actions';
import constants from 'src/constants';
import selectors from './selectors';

const { MAXIMUM_UNDO_ENTRIES } = constants.app;

const initialState = {
  isOperationInProgress: false,
  undoStack: [],
  redoStack: [],
};

const ADD_REDO_ENTRY = 'DESIGN_PRO/UNDO/ADD_REDO_ENTRY';
const ADD_UNDO_ENTRY = 'DESIGN_PRO/UNDO/ADD_UNDO_ENTRY';
const CLEAR_REDO_STACK = 'DESIGN_PRO/UNDO/CLEAR_REDO_STACK';
const HANDLE_REDO_CLICK = 'DESIGN_PRO/UNDO/HANDLE_REDO_CLICK';
const HANDLE_UNDO_CLICK = 'DESIGN_PRO/UNDO/HANDLE_UNDO_CLICK';
const RECORD_UNDOABLE_ACTION = 'DESIGN_PRO/UNDO/RECORD_UNDOABLE_ACTION';
const REMOVE_DELETED_SPLIT_ENTRIES =
  'DESIGN_PRO/UNDO/REMOVE_DELETED_SPLIT_ENTRIES';
const REMOVE_REDO_ENTRY = 'DESIGN_PRO/UNDO/REMOVE_REDO_ENTRY';
const REMOVE_UNDO_ENTRY = 'DESIGN_PRO/UNDO/REMOVE_UNDO_ENTRY';
const SET_IS_OPERATION_IN_PROGRESS =
  'DESIGN_PRO/UNDO/SET_IS_OPERATION_IN_PROGRESS';
const SET_UNDO_REDO_STACKS = 'DESIGN_PRO/UNDO/SET_UNDO_REDO_STACKS';

const actions = createActions({
  [ADD_REDO_ENTRY]: ({ originalType, data }) => ({
    data,
    originalType,
  }),
  [ADD_UNDO_ENTRY]: ({ originalType, data }) => ({
    data,
    originalType,
  }),
  [CLEAR_REDO_STACK]: () => null,
  [HANDLE_REDO_CLICK]: () => null,
  [HANDLE_UNDO_CLICK]: () => null,
  [RECORD_UNDOABLE_ACTION]: ({ originalType, data, isUndo }) => ({
    data,
    originalType,
    isUndo,
  }),
  [REMOVE_DELETED_SPLIT_ENTRIES]: (uuids) => ({ uuids }),
  [REMOVE_REDO_ENTRY]: () => null,
  [REMOVE_UNDO_ENTRY]: () => null,
  [SET_IS_OPERATION_IN_PROGRESS]: (isInProgress) => ({ isInProgress }),
  [SET_UNDO_REDO_STACKS]: ({ undoStack, redoStack }) => ({
    undoStack,
    redoStack,
  }),
});

const limitArrayLength = (array) => {
  if (array.length > MAXIMUM_UNDO_ENTRIES) {
    array.length = MAXIMUM_UNDO_ENTRIES;
  }
  return array;
};

const reducer = handleActions(
  {
    [actions.designPro.undo.removeRedoEntry]: (state) => ({
      ...state,
      redoStack: state.redoStack.slice(1),
    }),
    [actions.designPro.undo.removeUndoEntry]: (state) => ({
      ...state,
      undoStack: state.undoStack.slice(1),
    }),
    [actions.designPro.undo.addRedoEntry]: (state, action) => ({
      ...state,
      redoStack: limitArrayLength([action.payload, ...state.redoStack]),
    }),
    [actions.designPro.undo.addUndoEntry]: (state, action) => ({
      ...state,
      undoStack: limitArrayLength([action.payload, ...state.undoStack]),
    }),
    [actions.designPro.undo.clearRedoStack]: (state) => ({
      ...state,
      redoStack: [],
    }),
    [actions.designPro.undo.setIsOperationInProgress]: (state, action) => ({
      ...state,
      isOperationInProgress: action.payload.isInProgress,
    }),
    [actions.designPro.undo.setUndoRedoStacks]: (state, action) => ({
      ...state,
      undoStack: action.payload.undoStack,
      redoStack: action.payload.redoStack,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.undo,
  reducer,
  selectors,
};
